import { Controller } from "@hotwired/stimulus"

import { CursorPreview } from "../services/cursor_preview"

import type { CursorPackPayload } from "../extension/client.types"

export default class extends Controller<HTMLElement> {
  disconnect() {
    CursorPreview.stop(this.element)
  }

  toggle(event: Event) {
    CursorPreview.toggle(event.currentTarget as Element, this.#cursorPackPayload.cursorConfig)
  }

  #parsedCursorPackPayload?: CursorPackPayload
  get #cursorPackPayload(): CursorPackPayload {
    return (this.#parsedCursorPackPayload ??= JSON.parse(this.element.dataset.cursorPackPayload!))
  }
}
